module.exports = __webpack_public_path__ + "fonts/Inter-300-greek-ext20.2329210.woff2";